import { HttpClient } from '@angular/common/http';
// const GraphQLJSClient = require('graphql-js-client');
// @ts-ignore
import GraphQLJSClient from 'graphql-js-client';
import { effect, inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Types } from '../schema/types';
import { Store } from '@ngrx/store';
import { getActiveStorefront } from 'src/app/storefronts/store';
import { filter, take } from 'rxjs';
import { GraphQLFetcher } from './graph-ql-fetcher.service';

// graphql.service.ts
@Injectable()
export class GraphQLService {
  protected store = inject(Store);
  private graphQLFetcher = inject(GraphQLFetcher);
  activeStorefront = this.store.select(getActiveStorefront);
  client: any;

  constructor() {
    this.activeStorefront
      .pipe(
        filter(a => a?.storefrontToken !== undefined),
        take(1)
      )
      .subscribe(storefront => {
        this.setClient(storefront!.storefrontToken);
      });
    // prev used before unstable version 2022-04
  }

  setClient(token: string) {
    this.client = new GraphQLJSClient(Types, {
      fetcher: (request: any) =>
        this.graphQLFetcher.fetch(`${environment.storeDomain}api/2024-07/graphql.json`, {
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request),
        }),
    });
  }
}
